import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PageSection } from '@ui/components/PageSection'
import { Tab } from '@ui/components/Tabs'

import { useWindowResize } from '@utils/domUtils'

import { WalletTypeEnum } from '@model/WalletDto'

import { FirstTimeGuideCarousel } from '@shared/components/FirstTimeGuideCarousel/FirstTimeGuideCarousel'

import { TradingAccountBalances } from './TradingAccounts/TradingAccountBalances'
import { WalletBalances } from './Wallets/WalletBalances'

import styles from './BalancesPage.module.scss'

interface BalancesPageProps {
  walletType: WalletTypeEnum
}

export const BalancesPage: React.FC<BalancesPageProps> = ({ walletType }) => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()
  const [tab, setTab] = useState('wallets')

  const tabs: Tab[] = useMemo(
    () => [
      { label: t('Tabs.Wallets'), id: 'wallets' },
      { label: t('Tabs.Trading Accounts'), id: 'trading-accounts' },
    ],
    [t]
  )

  const activeTabIndex = tabs.findIndex((t) => t.id === tab)

  return (
    <div>
      {isMobile && (
        <PageSection
          title={t('Tabs.Balances')}
          tabData={{
            tabs,
            onTabClick: (tab) => setTab(tab.id ?? ''),
            initialIndex: activeTabIndex,
          }}
        />
      )}

      <FirstTimeGuideCarousel disabled walletType={walletType} />
      <div className={styles.balances}>
        {(tab === 'wallets' || !isMobile) && (
          <div className={styles.wallets}>
            <WalletBalances walletType={walletType} />
          </div>
        )}
        {(tab === 'trading-accounts' || !isMobile) && (
          <div className={styles.tradingAccounts}>
            <TradingAccountBalances />
          </div>
        )}
      </div>
    </div>
  )
}
